export const NOW_STEP = "NOW_STEP";
export const IFL_STATE = "IFL_STATE";
export const LEVEL = "LEVEL";
export const IMAGE = "IMAGE";
export const MARKER_INDEX = 'MARKER_INDEX';
export const MARKERS_ACTIVITY = 'MARKERS_ACTIVITY';
export const IMAGE_LAYOUT = 'IMAGE_LAYOUT';
export const SLIDER_STATE = 'SLIDER_STATE';
export const PLACE_HOLDER_LAYOUT = 'PLACE_HOLDER_LAYOUT';
export const SCREEN_SIZE = 'SCREEN_SIZE';
export const MARKER_NOW = 'MARKER_NOW';